export default "__VITE_ASSET__KB8nP_3y__"